import { Component, OnInit } from '@angular/core';
import {RoleService} from '../../../services/role.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-must-activate-mfa',
  templateUrl: './must-activate-mfa.component.html',
  styleUrls: ['./must-activate-mfa.component.css']
})
export class MustActivateMfaComponent implements OnInit {
  alreadyActive = false;

  constructor(
    private roleService: RoleService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if ( this.roleService.hasRoles('multi_factor_auth')) {
      this.alreadyActive = true;
      return;
    }
  }

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  goToActivateTotp() {
    this.router.navigate(['..', 'activate-totp'], { relativeTo: this.route });
  }

}
